/* eslint-disable simple-import-sort/imports */
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// MSAL Imports
import {} from // MSAL_GUARD_CONFIG,
// MSAL_INSTANCE,
// MSAL_INTERCEPTOR_CONFIG,
// MsalBroadcastService,
// MsalGuard,
// MsalGuardConfiguration,
// MsalInterceptor,
// MsalInterceptorConfiguration,
// MsalRedirectComponent,
// MsalService,
'@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';

// PrimeNG Imports
import { ConfirmationService, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

// Other Imports
import { environment } from '@environments';
import { AppRoutingModule } from './app-routing.module';
import { SharedGlobalModule } from './shared-global/shared-global.module';
import { OSidebarModule } from './shared-global/modules/sidebar/sidebar.module';
import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AccessRequiredComponent } from './access-required/access-required.component';
import { LoggerService as logger } from './shared-global/services/logger.service';
import { AbilityModule } from '@casl/angular';
import { CommonHeadersInterceptor } from './shared-global/interceptors/common-headers.interceptor';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal

export function loggerCallback(logLevel: LogLevel, message: string) {
  logger.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AZURE_SSO_CLIENT_ID,
      authority: `https://login.microsoftonline.com/common`,
      redirectUri: environment.REDIRECT_URL || '/via-ui/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11. Remove this line to use Angular Universal
    },
    system: {
      allowNativeBroker: false,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  });
}

// export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
//   const protectedResourceMap = new Map<string, Array<string>>();
//   protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
//     'user.read',
//   ]);
//   protectedResourceMap.set('https://graph.microsoft.com/v1.0/users', [
//     'user.read',
//   ]);
//   protectedResourceMap.set(`${environment.BASE_URL}`, [
//     `${environment.AZURE_SSO_SCOPE_URI}`,
//     'openid',
//     'profile',
//     'email',
//     'offline_access',
//   ]);
//protectedResourceMap.set('https://graph.microsoft.com/v1.0/me/photo', ['user.read']);
// protectedResourceMap.set('https://graph.microsoft-ppe.com/v1.0/me', ['user.read']); // PPE testing environment

//   return {
//     interactionType: InteractionType.Redirect,
//     protectedResourceMap,
//   };
// }

// export function MSALGuardConfigFactory(): MsalGuardConfiguration {
//   return {
//     interactionType: InteractionType.Redirect,
//     authRequest: {
//       scopes: ['user.read'],
//     },
//     loginFailedRoute: '/login-failed',
//   };
// }

@NgModule({
  declarations: [AppComponent, PageNotFoundComponent, AccessRequiredComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedGlobalModule,
    OSidebarModule,
    ToastModule,
    AbilityModule,
  ],
  providers: [
    Title,
    MessageService,
    ConfirmationService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true,
    // },
    // {
    //   provide: MSAL_INSTANCE,
    //   useFactory: MSALInstanceFactory,
    // },
    // {
    //   provide: MSAL_GUARD_CONFIG,
    //   useFactory: MSALGuardConfigFactory,
    // },
    // {
    //   provide: MSAL_INTERCEPTOR_CONFIG,
    //   useFactory: MSALInterceptorConfigFactory,
    // },
    // MsalService,
    // MsalGuard,
    // MsalBroadcastService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: CommonHeadersInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
